import { BAILocale } from '.';
import de_DE from 'antd/es/locale/de_DE';

const localeValue: BAILocale = {
  lang: 'de',
  antdLocale: de_DE,
};

export default localeValue;
